<template>
    <v-list-item :to="item.to" :href="item.href" v-if="!item.items && hasPermission" exact :class="isActive ? 'secondary' : ''">
        <v-list-item-icon v-if="item.icon">
            <v-icon small>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title v-text="item.title"></v-list-item-title>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import User from "@/models/User/User";

export default {
    props: {
        item: {
            required: true,
            type: Object,
        },
    },
    computed: {
        hasPermission() {
            return !this.item.permission || User.loggedInUser().HasPermission(this.item.permission);
        },
        isActive() {
            if (this.item.to === this.$route.path) {
                return true;
            }

            if (this.$route.meta.activates && this.item.to === this.$route.meta.activates) {
                return true;
            }

            return false;
        }
    },
}
</script>
